export const extractElementAttributes = <T extends Element>(element: T): Record<string, string> => {
  return Array.from(element.attributes)
    .filter(a => !['class', 'data-hmr', 'data-qwik-inspector'].includes(a.name))
    .reduce((acc, attr) => {
      const words = attr.name.split('-');
      const name = `${words[0]}${words
        .slice(1)
        .map(n => n.charAt(0).toUpperCase() + n.slice(1))
        .join('')}`;
      acc[name] = attr.value;
      return acc;
    }, {});
};

export const isMobile = () => {
  if (typeof window === 'undefined') return;
  return window.innerWidth < 768;
};
